const baseUrl = process.env.VUE_APP_WEB_COMERCIAL;

const apiWPService = ({ endpoint }) => {
  const url = `${baseUrl}${endpoint}`;
  return fetch(url);
};

export { apiWPService };
